import { h, render } from 'preact'
import FreeGiftSelector from '../components/free-gift-selector'

export default function FreeGiftSelection() {
  this.renderFreeGiftSelection = async function(freeGiftDiv) {
    if (freeGiftDiv.classList.contains('free-gift-selection-rendered')) return

    const componentJson = document.getElementById('free-items-data')
    if (!componentJson) return
    const data = JSON.parse(componentJson.text)

    const checkoutButton = document.querySelector('.cart-page button[name="checkout"]')
    if (!checkoutButton) return

    freeGiftDiv.classList.add('free-gift-selection-rendered')
    if (data.cartValue >= 10000) {
      if (data.products && data.products.length > 0) {
        freeGiftDiv.classList.add('show-free-gifts')
        const props = {
          products: data.products,
          selectedId: parseInt(freeGiftDiv.dataset.selectedId, 10),
          monogram: freeGiftDiv.dataset.monogram,
          initial1: freeGiftDiv.dataset.initial1,
          initial2: freeGiftDiv.dataset.initial2,
          initial3: freeGiftDiv.dataset.initial3,
          checkoutButton
        }
        render(h(FreeGiftSelector, props), freeGiftDiv)
      }
    } else {
      if (!freeGiftDiv.dataset.selectedId) return

      const updates = {}
      // Update the free gift variant to have a quantity of zero.
      updates[freeGiftDiv.dataset.selectedId] = 0

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      })

      const alert = <div class="cart-alerts">
        <div class="cart-alert">
          <i class="fa fa-flag" />
          Free item removed from cart since your cart total is now less than $100.
        </div>
      </div>

      render(alert, freeGiftDiv)

      freeGiftDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }

  this.render = function() {
    document.querySelectorAll('.free-gift-selection').forEach(freeGiftDiv => this.renderFreeGiftSelection(freeGiftDiv))

    const dataObserver = new MutationObserver((mutationList) => {
      mutationList.forEach((record) => {
        record.target.querySelectorAll('.free-gift-selection').forEach(freeGiftDiv => this.renderFreeGiftSelection(freeGiftDiv))
      })
    })

    dataObserver.observe(document.querySelector('.cart-page .js-ajax-cart-content'), { childList: true })
  }
}
